import { PaymentApi } from '@smartswap/client-api';
import { config } from '@/configuration';

const paymentApi = new PaymentApi(config);

export async function getMyCards() {
	return await paymentApi.myCardsGet();
}
